module.exports = __webpack_public_path__ + "dcded97f1ff0c68bea47a83590da120f.png";